module.exports = __webpack_public_path__ + "img/angle_300.9f7d7cfb.jpg";